import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/plan/view/license.plan.migrations.query.gql"
import type {
  PlanMigrationsQuery,
  PlanMigrationsQueryVariables,
} from "@/v2-backoffice-client/license/plan/view/__types__/license.plan.migrations.query"

export function usePlanMigrationsQuery(
  options?: QueryHookOptions<PlanMigrationsQuery, PlanMigrationsQueryVariables>,
) {
  return useQuery<PlanMigrationsQuery, PlanMigrationsQueryVariables>(
    query,
    options,
  )
}
